class RestfulClientCore {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  #resolveUrl(path) {
    return `${this.baseUrl}/${path}`;
  }

  /**
   * Request with a valid session
   * @param {string} path
   * @param {fetch.RequestInit} param1
   * @returns
   */
  async #request(path, { method, body, headers }) {
    const response = await fetch(this.#resolveUrl(path), {
      method,
      headers: {
        ...(headers || {}),
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });

    let jsonPayload;

    try {
      jsonPayload = await response.json();
    } catch (e) {}

    if (response.ok) {
      return jsonPayload;
    } else {
      console.error(jsonPayload);
      throw new Error(response.statusText);
    }
  }

  /**
   * Perform a GET with a valid session.
   * @param {string} path the path without url
   */
  async get(path) {
    return this.#request(path, {
      method: 'GET',
    });
  }

  /**
   * Perform a POST with a valid session.
   * @param {string} path the path without url
   * @param {object} body the payload data
   */
  async post(path, body) {
    return this.#request(path, {
      method: 'POST',
      body,
    });
  }
}

module.exports = RestfulClientCore;
